export default function Stack({
  children,
  justify = 'between',
  align = 'center',
  direction = 'col',
  width='11/12',
  className = '',
  gap='1' }) {
    const justifyClass = {
      start: 'justify-start',
      center: 'justify-center',
      end: 'justify-end',
      between: 'justify-between',
      around: 'justify-around',
      evenly: 'justify-evenly'
    }[justify] || 'justify-between';

    const alignClass = {
      start: 'items-start',
      center: 'items-center',
      end: 'items-end',
      stretch: 'items-stretch'
    }[align] || 'items-center';

    const directionClass = {
      row: 'flex-row',
      col: 'flex-col'
    }[direction] || 'flex-col';

    const widthClass = {
      full: 'w-full',
      auto: 'w-auto',
      '11/12': 'w-11/12',
      '10/12': 'w-10/12',
      '9/12': 'w-9/12',
      '8/12': 'w-8/12',
      '7/12': 'w-7/12',
      '6/12': 'w-6/12',
    }[width] || 'w-11/12';

    const gapClass = {
      0: 'gap-0',
      1: 'gap-1',
      2: 'gap-2',
      3: 'gap-3',
      4: 'gap-4',
      5: 'gap-5',
      6: 'gap-6',
      8: 'gap-8',
      10: 'gap-10',
      12: 'gap-12',
      16: 'gap-16',
      20: 'gap-20',
      24: 'gap-24',
      32: 'gap-32'
    }[gap] || 'gap-1';

  return (
    <div className={`${widthClass} flex ${directionClass} ${alignClass} ${justifyClass} ${gapClass} ${className}`}>
      {children}
    </div>
  );
}
